import { useEffect, useState } from "react";
import {
  Autocomplete,
  FormControl,
  Grid,
  InputAdornment,
  TextField,
  IconButton,
  MaskedInput,
} from "../../../components";
import {
  notification,
} from "../../../services";
import { value } from "../../../helpers";
import { responseErros } from "../../../utils";

export default function TabEndereco({
  enderecoSelecionado,
  linhaSelecionada,
  inputErros,
  setLoading,
  enderecoService,
  estados,
}) {
  const [cidades, setCidades] = useState([]);
  const [ufId, setUfId] = useState(enderecoSelecionado?.estadoId);
  const [cidadeId, setCidadeId] = useState(enderecoSelecionado?.cidadeId);
  const [endereco, setEndereco] = useState(enderecoSelecionado);

  useEffect(() => {
    changeCidadesByEstadoId(enderecoSelecionado?.estadoId);
  }, []);

  const changeCidadesByEstadoId = async (id) => {
    if (id) {
      enderecoService.getCidades(id).then((response) => {
        if (!response.isAxiosError) {
          if (!response.data) {
            notification.erroValidacao("Preencha um estado");
          } else {
            setCidades(response.data);
          }
        } else {
          responseErros(response);
        }
      });
    }
  };

  const handleEstadoUfInput = async (e, newValue) => {
    e.persist();
    setUfId(newValue?.id || null);
    if (newValue?.id) {
      changeCidadesByEstadoId(newValue.id);
    enderecoSelecionado.setAtributo("estadoId", newValue?.id);
    }
  };

  const handleCidadeInput = (e, newValue) => {
    e.persist();
    setCidadeId(newValue?.id || null);
    enderecoSelecionado.setAtributo("cidadeId", newValue?.id);
  };

  const handleChangeInput = (event) => {
    const { name, value } = event.target;
    enderecoSelecionado.setAtributo(name, value);
    setEndereco({ ...enderecoSelecionado });
  };

  const handleCompletarEndereco = async () => {
    setLoading(true);
    const res = await enderecoService.getByCep(endereco.cep.slice(0, 9));
    if (!res.isAxiosError) {
      setUfId(res.data.estado?.id);
      changeCidadesByEstadoId(res.data.estado?.id);
      setCidadeId(res.data.id);
      setEndereco({
        ...endereco,
        estadoId: res.data.estado?.id,
        bairro: res.data.bairro,
        logradouro: res.data.logradouro,
        cidade: res.data.nome,
        estado: res.data.estado?.sigla,
      });
    } else if (res.response.data.errors.length >= 5) {
      setEndereco({});
      setCidadeId(null);
      setUfId(null);
      setCidades([]);
      notification.alertaGenericos("CEP não encontrado.");
    } else responseErros(res);
    setLoading(false);
  };

  return (
    <Grid container spacing={2} className="mt-1">
      <Grid item xs={4}>
        <MaskedInput
          mask="99999-999"
          id="cep"
          name="cep"
          label="CEP"
          error={inputErros?.get("cep")}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="Pesquisar CEP"
                  onClick={() => handleCompletarEndereco()}
                >
                  <i
                    className="ph-bold ph-magnifying-glass"
                    style={{ color: "#494C62", fontSize: 18 }}
                  ></i>
                </IconButton>
              </InputAdornment>
            ),
          }}
          value={endereco?.cep ?? ""}
          onInput={handleChangeInput}
        />
      </Grid>
      <Grid item xs={4}>
        <TextField
          id="logradouro"
          name="logradouro"
          label="Endereço"
          variant="outlined"
          error={inputErros?.get(`[${linhaSelecionada}].endereco.logradouro`)}
          margin="normal"
          type="text"
          value={endereco?.logradouro ?? ""}
          onChange={handleChangeInput}
          fullWidth
          required
        />
      </Grid>
      <Grid item xs={4}>
        <TextField
          id="numero"
          name="numero"
          label="Número"
          variant="outlined"
          error={inputErros?.get(`[${linhaSelecionada}].endereco.numero`)}
          value={endereco?.numero ?? ""}
          onChange={handleChangeInput}
          margin="normal"
          required
          fullWidth
        />
      </Grid>
      <Grid item xs={4}>
        <TextField
          id="bairro"
          name="bairro"
          label="Bairro"
          variant="outlined"
          required
          margin="normal"
          error={inputErros?.get(`[${linhaSelecionada}].endereco.bairro`)}
          value={endereco?.bairro ?? ""}
          onChange={handleChangeInput}
          type="text"
          fullWidth
        />
      </Grid>
      <Grid item xs={4}>
        <TextField
          id="complemento"
          name="complemento"
          label="Complemento"
          variant="outlined"
          margin="normal"
          value={endereco?.complemento ?? ""}
          onChange={handleChangeInput}
          type="text"
          fullWidth
        />
      </Grid>
      <Grid item xs={4}>
        <FormControl variant="outlined" margin="normal" fullWidth>
          <Autocomplete
            required
            id="estado"
            name="estado"
            options={estados}
            noOptionsText="Sem opções"
            autoHighlight
            getOptionLabel={(option) =>
              option.sigla && option.nome
                ? `${option.sigla} - ${option.nome}`
                : ""
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="UF"
                required
                variant="outlined"
              />
            )}
            onChange={(event, newValue) =>
              handleEstadoUfInput(event, newValue)
            }
            value={value.autoComplete(estados, ufId)}
          />
        </FormControl>
      </Grid>
      <Grid item xs={4}>
        <FormControl variant="outlined" margin="normal" fullWidth>
          <Autocomplete
            required
            id="cidade"
            name="cidade"
            options={cidades}
            noOptionsText="Sem opções"
            autoHighlight
            getOptionLabel={(option) =>
              option.nome ? option.nome : ""
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Cidade"
                required
                variant="outlined"
              />
            )}
            onChange={(event, newValue) => {
              handleCidadeInput(event, newValue);
            }}
            value={value.autoComplete(cidades, cidadeId)}
          />
        </FormControl>
      </Grid>
      <Grid item xs={4}>
        <TextField
          id="descricao"
          name="descricao"
          label="Descrição"
          variant="outlined"
          margin="normal"
          value={endereco?.descricao ?? ""}
          onChange={handleChangeInput}
          placeholder="APTO, Casa, Trabalho..."
          type="text"
          fullWidth
        />
      </Grid>
    </Grid>
  );
}
